/* eslint-disable react-hooks/exhaustive-deps */
import { useLocation, withRouter } from "react-router-dom/cjs/react-router-dom";
import { withSnackbar } from "../../utils/SnackbarHOC";
import { useEffect, useState } from "react";
import { theme } from "../../utils/Theme";
import { Box, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { Card } from "@mui/material";
import ComparativeTable from "./Components/ComparativeTable";
import MonthlyEvolutionCharts from "./Components/MonthlyEvolutionCharts";
import KPIChart from "./Components/BarChart";
import BarChartt from "./Components/BarChart";
import FilterPilote from "./Components/FilterPilote";
import {getConsultantsAndManagers, getTalentManagers} from "../../services/UserService";
import { getAll } from "../../services/MissionService";
import Loader from "../../components/Loader/Loader";
import Diversity1 from '@mui/icons-material/Diversity1';
import ManageAccounts from '@mui/icons-material/ManageAccounts';
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {
  getPilotageClients, getPilotageCommercial,
  getPilotageConsultants,
} from "../../services/PilotageService";
import moment from "moment";
import {capitalise, getUserData} from "../../utils/FunctionHelpers";
import { useSelector } from "react-redux";
import Sourcing from "./Components/Sourcing/Sourcing";
import { getAllImportationSource } from "../../services/SourceService";
import MoneyRounded from '@mui/icons-material/MoneyRounded';
import {ROLE} from "../../enums/rolesEnum";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          hidden={value !== index}
          id={`full-width-tabpanel-${index}`}
          aria-labelledby={`full-width-tab-${index}`}
          {...other}
      >
        {value === index && (
            <Box>
              <div>{children}</div>
            </Box>
        )}
      </div>
  );
}

const Pilot = ({ snackbarShowMessage }) => {
  const [indexTab, setIndexTab] = useState(0);
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(true);
  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));
  const { filters } = useSelector((state) => state.filtersKPIConsultants);
  const [sourcesIds, setSourcesIds] = useState([]);
  const currentUserRole = getUserData()?.role;

  const filtersMissions = useSelector(
      (state) => state.filtersKPIMissions.filters
  );
  let initialChartsData;
  if (indexTab === 0) {
    initialChartsData = {
      prod: {
        id: "prod",
        list: [
          `Notes (${0})`,
          `Nouvelles Missions (${0})`,
          `Envois(${0})`,
          `Signatures (${0})`,
        ],
        values: [0, 0, 0, 0],
      },
      kpi: {
        id: "kpi",
        list: [
          `TT (Signatures/Envois): ${0}%`,
          `TBD (Nouvelles Missions/Notes): ${0}%`,
        ],
        values: [0, 0],
      },
    };
  } else {
    initialChartsData = {
      prod: {
        id: "prod",
        list: [
          `Prequalif (${0})`,
          `Envois client (${0})`,
          `Propales (${0})`,
          `Signatures (${0})`,
        ],
        values: [0, 0, 0, 0],
      },
      kpi: {
        id: "kpi",
        list: [
          `TR (Envois/préqualif): ${0}%`,
          `TP (Propales/Préqualif): ${0}%`,
          `TS (Sign/Préqualif): ${0}%`,
        ],
        values: [0, 0, 0],
      },
    };
  }

  const [chartsData, setChartsData] = useState(initialChartsData);
  const initialMonths = Array(12)
      .fill(0)
      .map((_, index) => capitalise(moment().month(index).format("MMM")));

  let initialEvolutionData;
  if (indexTab === 0) {
    initialEvolutionData = initialMonths.map((month) => ({
      Notes: 0,
      "Nouvelles Missions": 0,
      Envois: 0,
      Signatures: 0,
      month,
    }));
  } else {
    initialEvolutionData = initialMonths.map((month) => ({
      Prequalif: 0,
      EnvoisClient: 0,
      Propales: 0,
      Signatures: 0,
      month,
    }));
  }

  const [evolutionData, setEvolutionData] = useState(initialEvolutionData);
  const [compareData, setCompareData] = useState([]);
  const [missionData, setMissionData] = useState([]);
  const location = useLocation();

  const resetData = () => {
    setChartsData(initialChartsData);
    setEvolutionData(initialEvolutionData);
    setCompareData([]);
  };

  const resetParamsUrl = () => {
    const params = new URLSearchParams();
    params.append("statut", "910f357b-0b13-4f66-89a8-5c06964c1dcf");
    return params;
  };

  const getInitialParameters = () => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.toString()) return searchParams;
    return resetParamsUrl();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data } = await getAll(getInitialParameters());
        setMissionData(data.missions);
      } catch (error) {
        snackbarShowMessage(error.message, "error", 4000);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const queryParams = new URLSearchParams();
      try {
        if (indexTab === 0) {
          queryParams.append("role", "ROLE_TALENT_MANAGER");
        } else {
          queryParams.append("role", "ROLE_CONSULTANT");
        }
        setManagers([]);
        const search = `?${queryParams.toString()}`;
        const { data } = indexTab === 0
            ? await getTalentManagers(search)
            : await getConsultantsAndManagers(search);
        if (indexTab === 0) {
          setManagers(data);
        } else {
          setManagers(data.managers);
        }
        managers.filter((consultant) => consultant.uuid)
            .map((consultant) => consultant.uuid);
      } catch (error) {
        snackbarShowMessage(
            "Erreur de chargement des consultants et managers.",
            "error",
            4000
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [indexTab]);

  useEffect(() => {
    const fetchData = () => {
      resetData();
      if (indexTab === 0) {
        loadPilotageCommericial(
            filters.selectedConsultants,
            filters.startDate,
            filters.endDate
        );
      } else if (indexTab === 1) {
        resetData();
        loadPilotageConsultant(
            filters.selectedConsultants,
            filters.startDate,
            filters.endDate
        );
      } else if (indexTab === 2) {
        loadPilotageClients(
            filtersMissions.selectedMissions,
            filtersMissions.startDate || filters.startDate,
            filtersMissions.endDate || filters.endDate
        );
      } else if (indexTab === 3) {
        handleSourcing(
            filtersMissions.startDate || filters.startDate,
            filtersMissions.endDate || filters.endDate
        );
      } else {
        resetData();
      }
    };
    fetchData();
  }, [filters, filtersMissions, indexTab]);

  const loadData = (queryParams, requestService) => {
    setLoading(true);
    requestService(queryParams)
        .then(({ data }) => {
          const { Production, KPI, Evolution, Comparatif } = data;
          let localEvolutionData = [];
          if (indexTab === 0) {
            setChartsData({
              prod: {
                id: "prod",
                list: [
                  `Notes (${Production["notes"]})`,
                  `Nouvelles Missions (${Production["nouvelles missions"]})`,
                  `Envois (${Production["envois"]})`,
                  `Signatures (${Production["signatures"]})`,
                ],
                values: [
                  Production["notes"],
                  Production["nouvelles missions"],
                  Production["envois"],
                  Production["signatures"],
                ],
              },
              kpi: {
                id: "kpi",
                list: [
                  `TT (Signatures/Envois): ${KPI["TT"]}%`,
                  `TBD (Nouvelles Missions/Notes): ${KPI["TBD"]}%`,
                ],
                values: [KPI["TT"], KPI["TBD"]],
              },
            });
            Object.keys(Evolution).forEach((month) => {
              localEvolutionData.push({
                Notes: Evolution[month]["notes"],
                "Nouvelles Missions": Evolution[month]["nouvelles missions"],
                Envois: Evolution[month]["envois"],
                Signatures: Evolution[month]["signatures"],
                month,
              });
            });
          } else {
            setChartsData({
              prod: {
                id: "prod",
                list: [
                  `Prequalif (${Production["Prequalif"]})`,
                  `Envois client (${Production["Envois client"]})`,
                  `Propales (${Production["Propale"]})`,
                  `Signatures (${Production["Embauche/Integration"]})`,
                ],
                values: [
                  Production["Prequalif"],
                  Production["Envois client"],
                  Production["Propale"],
                  Production["Embauche/Integration"],
                ],
              },
              kpi: {
                id: "kpi",
                list: [
                  `TR (Envois/préqualif): ${KPI["TR"]}%`,
                  `TP (Propales/Préqualif): ${KPI["TP"]}%`,
                  `TS (Sign/Préqualif): ${KPI["TS"]}%`,
                ],
                values: [KPI["TR"], KPI["TP"], KPI["TS"]],
              },
            });
            Object.keys(Evolution).forEach((month) => {
              localEvolutionData.push({
                Prequalif: Evolution[month]["Prequalif"],
                Revelations: Evolution[month]["Envois client"],
                Propales: Evolution[month]["Propale"],
                Signatures: Evolution[month]["Embauche/Integration"],
                month,
              });
            });
          }
          setEvolutionData(localEvolutionData);
          setCompareData(Comparatif);
        })
        .catch((error) => {
          snackbarShowMessage("Erreur de chargement de données.", "error", 4000);
        })
        .finally(() => {
          setLoading(false);
        });
  };

  const loadPilotageConsultant = (consultants, startDate, endDate) => {
    const queryParams = `?consultants[]=${consultants.join(
        "&consultants[]="
    )}&startDate=${moment(startDate).format("YYYY-MM-DD")}&endDate=${moment(
        endDate
    ).format("YYYY-MM-DD")}`;
    loadData(queryParams, getPilotageConsultants);
  };

  const loadPilotageCommericial = (tms, startDate, endDate) => {
    const queryParams = `?tms[]=${tms.join(
        "&tms[]="
    )}&startDate=${moment(startDate).format("YYYY-MM-DD")}&endDate=${moment(
        endDate
    ).format("YYYY-MM-DD")}`;
    loadData(queryParams, getPilotageCommercial);
  };

  const loadPilotageClients = (missions, startDate, endDate) => {
    const queryParams = `?missions[]=${missions.join(
        "&missions[]="
    )}&startDate=${moment(startDate).format("YYYY-MM-DD")}&endDate=${moment(
        endDate
    ).format("YYYY-MM-DD")}`;
    loadData(queryParams, getPilotageClients);
  };

  const a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  };

  const handleSourcing = async (startDate, endDate) => {
    setLoading(true);
    const queryParams = new URLSearchParams();
    queryParams.append("startDate", moment(startDate).format("YYYY-MM-DD"));
    queryParams.append("endDate", moment(endDate).format("YYYY-MM-DD"));
    const search = `?${queryParams.toString()}`;
    try {
      const { data } = await getAllImportationSource(search);
      setSourcesIds(data);
    } catch (error) {
      snackbarShowMessage(
          "Erreur de chargement de sources d'importation!",
          "error",
          4000
      );
    } finally {
      setLoading(false);
    }
  };

  const kpiDatas = [
    {
      title: "PRODUCTION",
      component: <BarChartt data={chartsData.prod} />,
      cols: 6,
    },
    {
      title: "KPI",
      component: <KPIChart data={chartsData.kpi} />,
      cols: 6,
    },
    {
      title: "EVOLUTION MENSUELLE SUR 12 MOIS",
      component: <MonthlyEvolutionCharts data={evolutionData} index={indexTab}/>,
      cols: 12,
    },
    {
      title: indexTab === 0
          ? "TABLEAU COMPARATIF ENTRE LES TALENTS MANAGERS SUR LA PLAGE DE DATES CHOISIE"
          : "TABLEAU COMPARATIF ENTRE CONSULTANTS SUR LA PLAGE DE DATES CHOISIE",
      component: (
          <ComparativeTable
              {...(indexTab === 2 ? { showTsp: true } : { showTsp: false })}
              isLoading={loading}
              data={compareData}
              index={indexTab}
          />
      ),
      cols: 12,
    },
  ];

  const sourcingProps = {
    sourcesIds,
    loading,
  };

  const filterProps = {
    selectedConsultants: filters.selectedConsultants,
    consultants: managers,
    indexTab,
    missionData,
    snackbarShowMessage,
  };

  const cardSx = {
    border: '1px solid #e2e8f0',
    borderRadius: '14px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
    p: '20px 20px 14px',
    background: '#fff',
    minWidth: 0,
  };

  const cardTitleSx = {
    fontSize: '0.72rem', fontWeight: 700, color: '#94a3b8',
    letterSpacing: '0.08em', textTransform: 'uppercase', mb: 1.5,
  };

  const GenerateChartGrid = (data) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pb: 3 }}>
      {/* Row 1 — PRODUCTION + KPI side by side */}
      <Box sx={{ display: 'flex', gap: 2, minWidth: 0 }}>
        {(data || []).slice(0, 2).map((item) => (
          <Card key={item.title} elevation={0} sx={{ ...cardSx, flex: 1 }}>
            <Typography sx={cardTitleSx}>{item.title}</Typography>
            {item.component}
          </Card>
        ))}
      </Box>

      {/* Row 2 — EVOLUTION full width */}
      {data?.[2] && (
        <Card elevation={0} sx={cardSx}>
          <Typography sx={cardTitleSx}>{data[2].title}</Typography>
          {data[2].component}
        </Card>
      )}

      {/* Row 3 — TABLEAU COMPARATIF full width */}
      {data?.[3] && (
        <Card elevation={0} sx={{ ...cardSx, p: '0 0 0' }}>
          {data[3].component}
        </Card>
      )}
    </Box>
  );

  const tabs = [
    { title: "PILOTAGE COMMERCIAL", icon: <MoneyRounded /> },
    ...(!currentUserRole.includes(ROLE.TALENT_MANAGER)
        ? [
          { title: "PROD. et KPI Consultants", icon: <ManageAccounts /> },
          { title: "PROD. et KPI Clients", icon: <Diversity1 /> },
          { title: "Sourcing", icon: "" },
        ]
        : []),
  ];

  return (
      <Box sx={{ px: '20px', pb: 2, backgroundColor: '#f1f5f9', minHeight: '100vh' }}>

        {/* Header: title + tabs */}
        <Box sx={{ pt: 2, pb: 1, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Typography sx={{ color: '#0f172a', fontFamily: "'Fira Sans', sans-serif", fontWeight: 700, fontSize: '1.5rem', letterSpacing: '-0.01em', mr: 1 }}>
            PILOTAGE
          </Typography>
          <Tabs
              value={indexTab}
              onChange={(event, newValue) => setIndexTab(newValue)}
              TabIndicatorProps={{ style: { background: '#03407b', height: 3, borderRadius: 2 } }}
              sx={{
                minHeight: 38,
                '& .MuiTab-root': {
                  minHeight: 38, textTransform: 'none', fontWeight: 600, fontSize: '0.9rem',
                  color: '#64748b', px: 2, py: 0.75,
                  '&.Mui-selected': { color: '#03407b' },
                  '&.Mui-disabled': { opacity: 0.45 },
                },
              }}
              aria-label="pilotage tabs"
          >
            {tabs.map((tab, index) => (
                <Tab
                    key={index}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                        {tab.icon && <Box sx={{ display: 'flex', '& svg': { fontSize: 18 } }}>{tab.icon}</Box>}
                        {!isSmMode && <span>{tab.title}</span>}
                      </Box>
                    }
                    {...a11yProps(index)}
                    disabled={loading}
                />
            ))}
          </Tabs>
        </Box>

        {/* Main content */}
        <Box sx={{ display: 'flex', gap: 2, position: 'relative', alignItems: 'flex-start' }}>
          {loading && (
              <Box sx={{ display: 'flex', position: 'absolute', zIndex: 120, inset: 0, backgroundColor: 'rgba(241,245,249,0.7)', borderRadius: '14px' }}>
                <Loader />
              </Box>
          )}

          {/* Charts area — grows to fill, natural scroll on the page */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <TabPanel value={indexTab} index={0} dir={theme.direction}>
              {GenerateChartGrid(kpiDatas)}
            </TabPanel>
            <TabPanel value={indexTab} index={1} dir={theme.direction}>
              {GenerateChartGrid(kpiDatas)}
            </TabPanel>
            <TabPanel value={indexTab} index={2} dir={theme.direction}>
              {GenerateChartGrid(kpiDatas)}
            </TabPanel>
            <TabPanel value={indexTab} index={3} dir={theme.direction}>
              <Sourcing {...sourcingProps} />
            </TabPanel>
          </Box>

          {/* Filter sidebar — sticky so it stays in view while charts scroll */}
          <Box sx={{ position: 'sticky', top: 16, alignSelf: 'flex-start', flexShrink: 0 }}>
            <FilterPilote {...filterProps} />
          </Box>
        </Box>
      </Box>
  );
};

export default withSnackbar(Pilot);